import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../store";
import i18n from "../locales/i18n";
import { appActions } from "../store/slices/appSlice";

/**
 * Custom hook to manage app language globally
 * Automatically syncs i18n with Redux state
 * Persists language preference to AsyncStorage
 */
export const useLanguage = () => {
  const dispatch = useDispatch();
  const locale = useSelector((state: RootState) => state.app.locale);

  // Sync i18n with Redux locale whenever it changes
  useEffect(() => {
    if (locale && i18n.locale !== locale) {
      i18n.locale = locale;
    }
  }, [locale]);

  const changeLanguage = (newLocale: string) => {
    dispatch(appActions.setLocale(newLocale));
  };

  return {
    currentLanguage: locale,
    changeLanguage,
    isRTL: locale === "ar", // Arabic is RTL
  };
};
